function Incident() {
    "use strict";

    this.__type = 'Incident:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.Latitude = 0.0;
    this.Longitude = 0.0;

    this.CaseNumber = '';
    this.City = '';
    this.ClearedException = null;
    //this.ClearedDateUTC = new Date(-62135596800000); //fb 1527
    this.Country = '';
    this.Disposition = null;
    this.EndDateUTC = new Date(displayShortDate(new Date()));
    this.IncidentNumber = '';
    this.OrganizationId = -1;
    this.PrimaryOffense = -1;
    this.RespondingOfficer = '';
    this.StartDateUTC = new Date(displayShortDate(new Date().addDays(-1)));
    this.State = '';
    this.Status = 1;
    this.Street1 = '';
    this.Street2 = '';
    this.StreetAddressNumber = -1;
    this.TimeZoneCode = '';
    this.TimeZoneId = -1;
    this.Zipcode = '';
    this.Radius = -1;
    this.IsActive = true;
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = Incident;
}